import {css} from "@emotion/react";

import {calculateRemSize, p} from "@pg-design/helpers-css-strings";
import {CloseIcon} from "@pg-design/icons-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";

import {useAppSelector} from "../../../store/hooks";
import {ConsultantBoxType} from "../../types/ConsultantBoxType";
import {ForYouModalStep} from "../../types/ForYouModalStep";
import {ConsultantBox} from "../ConsultantBox";
import {ForYouModalProgress} from "./ForYouModalProgress";
import {ForYouStepDescription} from "./ForYouStepDescription";

interface IProps {
    onModalClose: () => void;
}

export const ForYouModalHeading = (props: IProps) => {
    const modalState = useAppSelector((state) => state.forYouModal);
    const {step, isLoading} = modalState;

    const renderHeading = () => {
        switch (step) {
            case ForYouModalStep.SUMMARY:
                return <div css={minimalHeadingStyle}>{closeButton(props.onModalClose)}</div>;
            case ForYouModalStep.ADDITIONAL:
                return (
                    <div css={additionalHeading}>
                        <div css={movingClose}>{closeButton(props.onModalClose)}</div>
                        {dialogComponent()}
                    </div>
                );
            case ForYouModalStep.SUCCESS:
                return isLoading ? (
                    <div css={baseHeading}>{progressComponent(props.onModalClose)}</div>
                ) : (
                    <div css={minimalHeadingStyle}>{closeButton(props.onModalClose)}</div>
                );
            default:
                return (
                    <div css={baseHeading}>
                        {progressComponent(props.onModalClose)}
                        {dialogComponent()}
                    </div>
                );
        }
    };

    return renderHeading();
};

const closeButton = (onModalClose: () => void) => <CloseIcon size="2" wrapperSize="2" wrapperColor="transparent" onClick={onModalClose} />;

const progressComponent = (onModalClose: () => void) => (
    <div css={progressWrapper}>
        <ForYouModalProgress />
        {closeButton(onModalClose)}
    </div>
);

const dialogComponent = () => (
    <div css={consultantDialog}>
        <ForYouStepDescription />
        <ConsultantBox type={ConsultantBoxType.PHONE} />
    </div>
);

const placeOnEnd = css`
    display: flex;
    justify-content: end;
`;

const movingClose = css`
    ${placeOnEnd};

    @media (min-width: ${getThemeBreakpoint().md}) {
        position: absolute;
        top: 12px;
        right: 12px;
    }
`;

const minimalHeadingStyle = css`
    ${placeOnEnd};
    margin-left: -${calculateRemSize(2)};
    ${p(1.5)};
    background-color: ${getThemeVariable("colors.gray.100")};
`;

const headingStyle = css`
    display: flex;
    flex-direction: column;
    gap: ${calculateRemSize(3)};
    margin-left: -${calculateRemSize(2)};
    background-color: ${getThemeVariable("colors.gray.200")};
    ${p(1.5)};
`;

const baseHeading = css`
    ${headingStyle};
`;

const additionalHeading = css`
    ${headingStyle};
    gap: ${calculateRemSize(2)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(1.5, 5, 1.5, 1.5)};
    }
`;

const progressWrapper = css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: ${calculateRemSize(2)};
`;

const consultantDialog = css`
    display: flex;
    flex-direction: row;
    gap: ${calculateRemSize(1)};

    .consultant-box {
        background-color: #fff;
        flex-direction: column;
        justify-content: center;
        min-width: 124px;
        p {
            text-align: center;
        }
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        gap: ${calculateRemSize(3)};

        .consultant-box {
            flex-direction: row;
            justify-content: start;
            min-width: 234px;
            p {
                text-align: start;
            }
        }
    }
`;
import {css} from "@emotion/react";

import {calculateRemSize, p} from "@pg-design/helpers-css-strings";
import {CloseIcon} from "@pg-design/icons-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";

import {useAppSelector} from "../../../store/hooks";
import {ConsultantBoxType} from "../../types/ConsultantBoxType";
import {ForYouModalStep} from "../../types/ForYouModalStep";
import {ConsultantBox} from "../ConsultantBox";
import {ForYouModalProgress} from "./ForYouModalProgress";
import {ForYouStepDescription} from "./ForYouStepDescription";

interface IProps {
    onModalClose: () => void;
}

export const ForYouModalHeading = (props: IProps) => {
    const modalState = useAppSelector((state) => state.forYouModal);
    const {step, isLoading} = modalState;

    const renderHeading = () => {
        switch (step) {
            case ForYouModalStep.SUMMARY:
                return <div css={minimalHeadingStyle}>{closeButton(props.onModalClose)}</div>;
            case ForYouModalStep.ADDITIONAL:
                return (
                    <div css={additionalHeading}>
                        <div css={movingClose}>{closeButton(props.onModalClose)}</div>
                        {dialogComponent()}
                    </div>
                );
            case ForYouModalStep.SUCCESS:
                return isLoading ? (
                    <div css={baseHeading}>{progressComponent(props.onModalClose)}</div>
                ) : (
                    <div css={minimalHeadingStyle}>{closeButton(props.onModalClose)}</div>
                );
            default:
                return (
                    <div css={baseHeading}>
                        {progressComponent(props.onModalClose)}
                        {dialogComponent()}
                    </div>
                );
        }
    };

    return renderHeading();
};

const closeButton = (onModalClose: () => void) => <CloseIcon size="2" wrapperSize="2" wrapperColor="transparent" onClick={onModalClose} />;

const progressComponent = (onModalClose: () => void) => (
    <div css={progressWrapper}>
        <ForYouModalProgress />
        {closeButton(onModalClose)}
    </div>
);

const dialogComponent = () => (
    <div css={consultantDialog}>
        <ForYouStepDescription />
        <ConsultantBox type={ConsultantBoxType.PHONE} />
    </div>
);

const placeOnEnd = css`
    display: flex;
    justify-content: end;
`;

const movingClose = css`
    ${placeOnEnd};

    @media (min-width: ${getThemeBreakpoint().md}) {
        position: absolute;
        top: 12px;
        right: 12px;
    }
`;

const minimalHeadingStyle = css`
    ${placeOnEnd};
    margin-left: -${calculateRemSize(2)};
    ${p(1.5)};
    background-color: ${getThemeVariable("colors.gray.100")};
`;

const headingStyle = css`
    display: flex;
    flex-direction: column;
    gap: ${calculateRemSize(3)};
    margin-left: -${calculateRemSize(2)};
    background-color: ${getThemeVariable("colors.gray.200")};
    ${p(1.5)};
`;

const baseHeading = css`
    ${headingStyle};
`;

const additionalHeading = css`
    ${headingStyle};
    gap: ${calculateRemSize(2)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(1.5, 5, 1.5, 1.5)};
    }
`;

const progressWrapper = css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: ${calculateRemSize(2)};
`;

const consultantDialog = css`
    display: flex;
    flex-direction: row;
    gap: ${calculateRemSize(1)};

    .consultant-box {
        background-color: #fff;
        flex-direction: column;
        justify-content: center;
        min-width: 124px;
        p {
            text-align: center;
        }
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        gap: ${calculateRemSize(3)};

        .consultant-box {
            flex-direction: row;
            justify-content: start;
            min-width: 234px;
            p {
                text-align: start;
            }
        }
    }
`;
